export function arrayBufferToBase64(arrayBuffer) {
    var byteArray = new Uint8Array(arrayBuffer);
    var byteString = '';
    for (var i = 0; i < byteArray.byteLength; i++) {
        byteString += String.fromCharCode(byteArray[i]);
    }
    var b64 = window.btoa(byteString);

    return b64;
}

function toHexString(byteArray) {
    return Array.from(byteArray, function (byte) {
        return ('0' + (byte & 0xFF).toString(16)).slice(-2);
    }).join('')
}

export function base64ToArrayBuffer(base64) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
}

function mergeTypedArrays(a, b) {
    // Checks for truthy values on both arrays
    if (!a && !b) throw 'Please specify valid arguments for parameters a and b.';

    // Checks for truthy values or empty arrays on each argument
    // to avoid the unnecessary construction of a new array and
    // the type comparison
    if (!b || b.length === 0) return a;
    if (!a || a.length === 0) return b;

    // Make sure that both typed arrays are of the same type
    if (Object.prototype.toString.call(a) !== Object.prototype.toString.call(b))
        throw 'The types of the two arguments passed for parameters a and b do not match.';

    var c = new a.constructor(a.length + b.length);
    c.set(a);
    c.set(b, a.length);

    return c;
}

export function generateRSAKey() {
    return window.crypto.subtle.generateKey(
        {
            name: "RSA-OAEP",
            modulusLength: 4096,
            publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
            hash: {name: "SHA-256"},
        },
        true,
        ["encrypt", "decrypt"]
    )
}

export function exportRSAPrivateKey(key) {
    return window.crypto.subtle.exportKey(
        "pkcs8",
        key
    )
}

export function exportRSAPublicKey(key) {
    return window.crypto.subtle.exportKey(
        "spki",
        key
    )
}

function importRSAPrivateKey(pem) {
    return window.crypto.subtle.importKey(
        "pkcs8",
        base64ToArrayBuffer(pem),
        {
            name: "RSA-OAEP",
            hash: "SHA-256"
        },
        false,
        ["decrypt"]
    );
}

function importRSAPublicKey(pem) {
    return window.crypto.subtle.importKey(
        "spki",
        base64ToArrayBuffer(pem),
        {
            name: "RSA-OAEP",
            hash: "SHA-256"
        },
        false,
        ["encrypt"]
    );
}

async function deriveAESKey(password) {
    let enc = new TextEncoder();
    let material = await window.crypto.subtle.importKey(
        "raw",
        enc.encode(password),
        "PBKDF2",
        false,
        ["deriveBits", "deriveKey"]
    );
    return window.crypto.subtle.deriveKey(
        {
            "name": "PBKDF2",
            salt: base64ToArrayBuffer("9108FDrCt58x78sC6JMDAJJdLgW2XXRBRq/SdKkny+0="),
            "iterations": 12000,
            "hash": "SHA-256"
        },
        material,
        {"name": "AES-CBC", "length": 256},
        false,
        ["encrypt", "decrypt"]
    );
}

function importAESKey(rawKey) {
    return window.crypto.subtle.importKey(
        "raw",
        rawKey,
        "AES-CBC",
        false,
        ["encrypt", "decrypt"]
    );
}

export async function generateAESKey() {
    let key = await window.crypto.subtle.generateKey(
        {
            name: "AES-CBC",
            length: 256,
        },
        true,
        ["encrypt", "decrypt"]
    );
    return window.crypto.subtle.exportKey(
        "raw",
        key
    )
}

export async function decryptTable(aesKey, tableData) {
    let ommit = ["id", "deleted_date", "updated_date", "created_date"];
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    for (let i = 0; i < tableData.length; i++) {
        let current = tableData[i];
        for (let prop in current) {
            if (Object.prototype.hasOwnProperty.call(current, prop)) {
                if (!ommit.includes(prop) && current[prop] !== "") {
                    current[prop] = await decryptEntry(key, current[prop]);
                }
            }
        }
        tableData[i] = current;
    }
    return tableData;
}

export async function decryptAddress(aesKey, addressData) {
    let include = ["name", "name_1", "first_name", "name_2", "birth_name", "street", "street_number", "phone_number", "fax", "phone_p", "email"];
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    for (let i = 0; i < addressData.length; i++) {
        let current = addressData[i];
        for (let prop in current) {
            if (Object.prototype.hasOwnProperty.call(current, prop)) {
                if (include.includes(prop) && current[prop] !== "") {
                    current[prop] = await decryptEntry(key, current[prop]);
                }
            }
        }
        addressData[i] = current;
    }
    return addressData;
}



export async function encryptAddress(aesKey, address) {
    let include = ["name", "name_1", "first_name", "name_2", "birth_name", "street", "street_number", "phone_number", "fax", "phone_p", "email"];
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    let result = {...address};
    for (let prop in result) {
        if (Object.prototype.hasOwnProperty.call(result, prop)) {
            if (include.includes(prop) && result[prop] !== '') {
                result[prop] = await encryptEntry(key, result[prop]);
            }
        }
    }
    return result;
}


export async function decryptEvent(aesKey, events) {
    let include = ["task_message", "todo_message"];
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey).catch(e => {
        console.log(e);
    });
    for (let i = 0; i < events.length; i++) {
        let current = events[i];
        for (let prop in current) {
            if (Object.prototype.hasOwnProperty.call(current, prop)) {
                if (include.includes(prop) && current[prop] !== "") {
                    current[prop] = await decryptEntry(key, current[prop]).catch(e => {
                        console.log(e);
                    });
                }
            }
        }
        events[i] = current;
    }
    return events;
}


export async function decryptSach(aesKey, sachData) {
    let include = ["name", "phone", "fax", "email"];
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    for (let i = 0; i < sachData.length; i++) {
        let current = sachData[i];
        for (let prop in current) {
            if (Object.prototype.hasOwnProperty.call(current, prop)) {
                if (include.includes(prop) && current[prop] !== "") {
                    current[prop] = await decryptEntry(key, current[prop]);
                }
            }
        }
        sachData[i] = current;
    }
    return sachData;
}

export async function encryptSach(aesKey, sachData) {
    let include = ["name", "phone", "fax", "email"];
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    let result = {...sachData};
    for (let prop in result) {
        if (Object.prototype.hasOwnProperty.call(result, prop)) {
            if (include.includes(prop) && result[prop] !== '') {
                result[prop] = await encryptEntry(key, result[prop]);
            }
        }
    }
    return result;
}


export async function encryptTask(aesKey, task) {
    let include = ["memo", "name_1", "name_2", "street", "ausfuehr", "email", "fax", "re_vorname", "re_name_1", "re_strh_nr"];
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    let result = {...task};
    for (let prop in result) {
        if (Object.prototype.hasOwnProperty.call(result, prop)) {
            if (include.includes(prop) && result[prop] !== '') {
                result[prop] = await encryptEntry(key, result[prop]);
            }
        }
    }
    return result;
}

export async function decryptTask(aesKey, task) {
    let include = ["memo", "name_1", "name_2", "street", "ausfuehr", "email", "fax", "re_vorname", "re_name_1", "re_strh_nr"];
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    for (let prop in task) {
        if (Object.prototype.hasOwnProperty.call(task, prop)) {
            if (include.includes(prop) && task[prop] !== "") {
                task[prop] = await decryptEntry(key, task[prop]);
            }
        }
    }
    return task;
}

export async function decryptMessages(aesKey, messages) {
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    for (let i = 0; i < messages.length; i++) {
        let current = messages[i];
        try {
            if (current.data.text !== null && current.data.text.startsWith("#")) {
                current.data.text = current.data.text.substring(1);
            }
            current.data.text = await decryptEntry(key, current.data.text);
            current.data.text = current.data.text.replace('\r\n', '\n');
        } catch (e) {

        }
        let res = JSON.parse(sessionStorage.getItem(current.data.meta_id));
        if (res !== null) {
            current.data.meta_name = res.full_name;
        }
        messages[i] = current;
    }
    return messages;
}

export async function encryptUser(aesKey, user) {
    let ommit = ["id", "deleted_date", "updated_date", "created_date"];
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    let result = {
        id: user.id
    };
    for (let prop in user) {
        if (Object.prototype.hasOwnProperty.call(user, prop)) {
            if (!ommit.includes(prop)) {
                if (prop === "username" && user[prop] === "") {
                    result["username"] = "";
                } else {
                    result[prop] = await encryptEntry(key, user[prop]);
                }
            }
        }
    }

    return result;
}

export async function encryptTodos(aesKey, todos) {
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    for (let i = 0; i < todos.length; i++) {
        let current = todos[i];
        if (Object.prototype.hasOwnProperty.call(current, 'memo')) {
            try {
                current['memo'] = await encryptEntry(key, current['memo']);
            } catch (e) {
                //console.log(e)
            }
        }
        todos[i] = current;
    }
    return todos;
}

export async function encryptServerTodos(aesKey, todos) {
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    for (let i = 0; i < todos.length; i++) {
        let current = todos[i];
        if (Object.prototype.hasOwnProperty.call(current, 'message')) {
            try {
                current['message'] = await encryptEntry(key, current['message']);
            } catch (e) {
                //console.log(e)
            }
        }
        todos[i] = current;
    }
    return todos;
}

export async function encryptAES(aesKey, message) {
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    let enc = new TextEncoder();
    let encodedBytes = enc.encode(message);
    let iv = await window.crypto.getRandomValues(new Uint8Array(16));
    let encrypted = await window.crypto.subtle.encrypt(
        {
            name: "AES-CBC",
            iv: iv.buffer,
        },
        key,
        encodedBytes
    );
    return arrayBufferToBase64(mergeTypedArrays(iv, new Uint8Array(encrypted)));
}

export async function encryptMultipleAES(aesKey, messages) {
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    let enc = new TextEncoder();
    let res = [];
    for (let i = 0; i < messages.length; i++) {
        let message = messages[i];
        let encodedBytes = enc.encode(message);
        let iv = await window.crypto.getRandomValues(new Uint8Array(16));
        let encrypted = await window.crypto.subtle.encrypt(
            {
                name: "AES-CBC",
                iv: iv.buffer,
            },
            key,
            encodedBytes
        );
        res.push(arrayBufferToBase64(mergeTypedArrays(iv, new Uint8Array(encrypted))));
    }
    return res;
}

export async function encryptAESWithPw(password, message) {
    let key = await deriveAESKey(password);
    let enc = new TextEncoder();
    let encodedBytes = enc.encode(message);
    let iv = await window.crypto.getRandomValues(new Uint8Array(16));
    let encrypted = await window.crypto.subtle.encrypt(
        {
            name: "AES-CBC",
            iv: iv.buffer,
        },
        key,
        encodedBytes
    );
    return arrayBufferToBase64(mergeTypedArrays(iv, new Uint8Array(encrypted)));
}

async function encryptAESWithPwFixedIV(password, message) {
    let key = await deriveAESKey(password);
    let enc = new TextEncoder();
    let encodedBytes = enc.encode(message);
    let iv = new Uint8Array([249, 208, 199, 136, 172, 221, 205, 33, 9, 10, 46, 174, 147, 220, 188, 211]);
    let encrypted = await window.crypto.subtle.encrypt(
        {
            name: "AES-CBC",
            iv: iv.buffer,
        },
        key,
        encodedBytes
    );
    return arrayBufferToBase64(mergeTypedArrays(iv, new Uint8Array(encrypted)));
}

export async function decryptAES(aesKey, message) {
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    if (message !== null && message.startsWith("#")) {
        message = message.substring(1);
    }
    let encryptedBytes = new Uint8Array(base64ToArrayBuffer(message));
    let iv = encryptedBytes.slice(0, 16);
    let cipher = encryptedBytes.slice(16, encryptedBytes.length);
    let res = new TextDecoder("utf-8").decode(new Uint8Array(await window.crypto.subtle.decrypt(
        {
            name: "AES-CBC",
            iv: iv
        },
        key,
        cipher
    )));
    return res;
}

export async function decryptFile(aesKey, file) {
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    let encryptedBytes = file;
    let iv = encryptedBytes.slice(0, 16);
    let cipher = encryptedBytes.slice(16, encryptedBytes.length);
    return new Uint8Array(await window.crypto.subtle.decrypt(
        {
            name: "AES-CBC",
            iv: iv
        },
        key,
        cipher
    ));
}

export async function encryptFile(aesKey, file) {
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    let encodedBytes = file;
    let iv = await window.crypto.getRandomValues(new Uint8Array(16));
    let encrypted = await window.crypto.subtle.encrypt(
        {
            name: "AES-CBC",
            iv: iv.buffer,
        },
        key,
        encodedBytes
    );
    return mergeTypedArrays(iv, new Uint8Array(encrypted));
}

async function decryptEntry(key, message) {
    let encryptedBytes;
    let res;
    try {
        encryptedBytes = new Uint8Array(base64ToArrayBuffer(message));
    let iv = encryptedBytes.slice(0, 16);
    let cipher = encryptedBytes.slice(16, encryptedBytes.length);
    res = new TextDecoder("utf-8").decode(new Uint8Array(await window.crypto.subtle.decrypt(
        {
            name: "AES-CBC",
            iv: iv
        },
        key,
        cipher
    )));
    } catch (e) {
        //console.log(e);
        return message;
    }
    return res;
}

export async function encryptEntry(key, message) {
    let enc = new TextEncoder();
    let encodedBytes = enc.encode(message);
    let iv = await window.crypto.getRandomValues(new Uint8Array(16));
    let encrypted = await window.crypto.subtle.encrypt(
        {
            name: "AES-CBC",
            iv: iv.buffer,
        },
        key,
        encodedBytes
    );
    return arrayBufferToBase64(mergeTypedArrays(iv, new Uint8Array(encrypted)));
}

export async function decryptAESWithPw(password, message) {
    let key = await deriveAESKey(password);
    let encryptedBytes = new Uint8Array(base64ToArrayBuffer(message));
    let iv = encryptedBytes.slice(0, 16);
    let cipher = encryptedBytes.slice(16, encryptedBytes.length);
    let res = new TextDecoder("utf-8").decode(new Uint8Array(await window.crypto.subtle.decrypt(
        {
            name: "AES-CBC",
            iv: iv
        },
        key,
        cipher
    )));
    return res;
}

export async function encryptRSA(pub, message) {
    let key = await importRSAPublicKey(pub);
    let encryptedBytes = new Uint8Array(message);
    let encrypted = await window.crypto.subtle.encrypt(
        {
            name: "RSA-OAEP",
        },
        key,
        encryptedBytes
    );
    return arrayBufferToBase64(new Uint8Array(encrypted));
}

export async function decryptRSA(priv, message) {
    let key = await importRSAPrivateKey(priv);
    let encryptedBytes = new Uint8Array(base64ToArrayBuffer(message));
    let encrypted = await window.crypto.subtle.decrypt(
        {
            name: "RSA-OAEP",
        },
        key,
        encryptedBytes
    );
    return new Uint8Array(encrypted);
}

export async function savePair(key, value) {
    let pair1 = await encryptAESWithPwFixedIV("PvpZGXsKvU", key);
    let pair2 = await encryptAESWithPw("PvpZGXsKvU", value);
    return [pair1, pair2];
}

export async function getKey(key) {
    return await encryptAESWithPwFixedIV("PvpZGXsKvU", key);
}

export async function getValue(value) {
    return  await decryptAESWithPw("PvpZGXsKvU", value);
}

// todo 10.03
export async function decryptInbox(aesKey, inboxData) {
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    for (let i = 0; i < inboxData.length; i++) {
        let current = inboxData[i];
            if (Object.prototype.hasOwnProperty.call(current, 'body')) {
                try {
                    current['body'] = await decryptEntry(key, current['body']);
                } catch (e) {
                    //console.log(e)
                }
            }
        if (Object.prototype.hasOwnProperty.call(current, 'memo') && current['memo'] !== "") {
            try {
                current['memo'] = await decryptEntry(key, current['memo']);
            } catch (e) {
                //console.log(e)
            }
        }
            current.hover = false;
            current.is_selected = false;
            current._rowVariant = "";
        inboxData[i] = current;
    }
    return inboxData;
}

export async function decryptRooms(aesKey, rooms) {
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    for (let i = 0; i < rooms.length; i++) {
        let current = rooms[i];
        if (Object.prototype.hasOwnProperty.call(current, 'latest_message') && current['latest_message'] !== null && current['latest_message']['content'] !== "") {
            try {
                current['latest_message']['content'] = await decryptEntry(key, current['latest_message']['content']);
            } catch (e) {
                //console.log(e)
            }
        }
        rooms[i] = current;
    }
    return rooms;
}

export async function decryptChatMessages(aesKey, messages) {
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    for (let i = 0; i < messages.length; i++) {
        let current = messages[i];
        if (Object.prototype.hasOwnProperty.call(current, 'content')  && current['content'] !== "") {
            try {
                current['content'] = await decryptEntry(key, current['content']);
            } catch (e) {
                //console.log(e)
            }
        }
        if (Object.prototype.hasOwnProperty.call(current, 'message_type')  && current['message_type'] === "task") {
            try {
                current['value_2'] = await decryptEntry(key, current['value_2']);
            } catch (e) {
                //console.log(e)
            }
        }
        messages[i] = current;
    }
    return messages;
}

export async function decryptArray(aesKey, messages) {
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    for (let i = 0; i < messages.length; i++) {
        let current = messages[i];
            try {
                current = await decryptEntry(key, current);
            } catch (e) {
                //console.log(e)
            }

        messages[i] = current;
    }
    return messages;
}

export async function decryptTodos(aesKey, todoData) {
    if (todoData === undefined || todoData === null || todoData.length === 0) {
        return todoData
    }
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    for (let i = 0; i < todoData.length; i++) {
        let current = todoData[i];
        if (Object.prototype.hasOwnProperty.call(current, 'message')) {
            try {
                current['message'] = await decryptEntry(key, current['message']);
            } catch (e) {
                console.log(e)
            }
        }
        todoData[i] = current;
    }
    return todoData;
}

export async function decryptPositions(aesKey, positions) {
    let rawKey = base64ToArrayBuffer(aesKey);
    let key = await importAESKey(rawKey);
    for (let prop in positions) {
        if (Object.prototype.hasOwnProperty.call(positions, prop)) {
            let children = positions[prop].positions;
            for (let i = 0; i < children.length; i++) {
                try {
                    children[i]['gi_leist'] = await decryptEntry(key, children[i]['gi_leist']);
                } catch (e) {
                    console.log(e)
                }
            }
            positions[prop].positions = children;

        }
    }
    return positions;
}
